import { Environment } from '@leanpay/utils'

import { AnalyticsConfig, AnalyticsContext } from './types'

export const getAnalyticsConfig = (context: AnalyticsContext): AnalyticsConfig => {
    const isProd = context.environment === Environment.PROD
    const hasApiKey = context.apiKey && context.apiKey.trim().length > 0

    return {
        apiKey: context.apiKey,
        apiHost: context.apiHost ?? 'https://eu.i.posthog.com',
        debug: !isProd,
        disabled: context.disabled ?? !hasApiKey,
        enableHeatmaps: context.enableHeatmaps ?? false,
    }
}

export const getBaseProperties = (context: AnalyticsContext): Record<string, any> => {
    return {
        app: context.app,
        market: context.market, // Keep original case (SLO, ROM, HUN)
        environment: context.environment.toLowerCase(),
        hostname: context.hostname,
    }
}
